import React, {useState,useEffect} from 'react';
import { Link} from 'react-router-dom'
import { ReactComponent as FacebookIcon } from '../../assets/icons/iconFace.svg';
import { ReactComponent as InstagramIcon } from '../../assets/icons/iconInsta.svg';
import { ReactComponent as TiktokIcon } from '../../assets/icons/iconTiktok.svg';
import { ReactComponent as IconContactMail } from '../../assets/icons/iconContactUs.svg';
import { ReactComponent as IconPhone } from '../../assets/icons/iconPhone.svg';
import { ReactComponent as IconStore } from '../../assets/icons/iconStore.svg';
import logoSP from "../../assets/LogoSP.svg";
import {fetchWithCache} from "../services/FirebaseData";
import './Footer.scss';

const baseData = {
  "socialLinks": {
    "instagram": "https://www.instagram.com/alterationssandp/",
    "facebook": "https://www.facebook.com/share/18ukhEJenf/",
    "tiktok": "https://www.tiktok.com/@alterationsbysden"
  },
  "contantInfo" : {
      "ubi": "9610 Stirling Rd, Unit 104, in Cooper City, FL",
      "ubiUrl" :"https://maps.app.goo.gl/HorxGWw6LVBbyv4v7",
      "gmail": "alterationsbysdenkaandpaola@gmail.com",
      "phone": "(954) 408-3514"
    },
}

const Footer = () => {
  const [content, setContent] = useState(baseData);

  useEffect(() => {
    fetchWithCache( "firebaseContent")
      .then((data) => setContent(data))
      .catch((error) => console.error("Error fetching content:", error));
  }, []);
  
    return (
      <footer className="footer">
        <div className="footer-content">
        <div className="contact-section">
          <h3>CONTACT</h3>
          <div className="contact-item">
            <IconStore className="contact-icon" />
            <a href={content.contantInfo.ubiUrl} className="contact-link"  target="_blank" rel="noopener noreferrer" > {content.contantInfo.ubi}</a>
          </div>
          <div className="contact-item">
            <IconContactMail className="contact-icon" />
            <a href={`mailto:${content.contantInfo.gmail}`} className="contact-link">{content.contantInfo.gmail}</a>
          </div>
          <div className="contact-item">
            <IconPhone className="contact-icon" />
             <a href={`tel:+1${content.contantInfo.phone.replace(/\D/g, '')}`} className="contact-link">
              {content.contantInfo.phone}
            </a>
          </div>
        </div>
        <img
          className="logo"
          src={logoSP}
          alt="Alterations by Sdenka & Paola Logo"
          aria-label="Logo Sp"
        />
        <div className="social-section">
            <div className="social-media">
              <h3>FOLLOW US</h3>
              <div >
              <a href={content.socialLinks.facebook} target="_blank" rel="noopener noreferrer" title="Visit us on Facebook">
                <FacebookIcon className="social-icon" />
              </a>
              <a href={content.socialLinks.instagram}  target="_blank" rel="noopener noreferrer" title="Visit us on Instagram">
                <InstagramIcon className="social-icon" />
              </a>
              <a href={content.socialLinks.tiktok} target="_blank" rel="noopener noreferrer" title="Visit us on TikTok">
                <TiktokIcon className="social-icon" />
              </a>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          &copy; 2025 Alterations by Sdenka and Paola. All rights reserved   |  
          <Link className='Terms' to={`/policy`}>
          Terms & Credits
          </Link>
        </div>
      </footer>
    );
  };
  
  export default Footer;